// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* EmployeeView.css */

.employee-view-container {
    display: flex;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
}

.clickableattachments{
    color: black;
    cursor: pointer;
    
}
.clickableattachments p:hover{
    color: blue;
    
}

.employee-card {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    width: 100%;
    max-width: 800px; /* Adjust width as necessary */
    padding: 20px;
    box-sizing: border-box;
}

.employee-image {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
}

.employee-details {
    width: 100%;
}

    .employee-details h2 {
        text-align: center;
        margin-bottom: 20px;
        color: #333;
    }

    .employee-details p {
        margin: 5px 0;
        font-size: 14px;
        color: #666;
    }

        .employee-details p strong {
            color: #333;
        }

    .employee-details hr {
        border: none;
        border-top: 1px solid #ddd;
        margin: 20px 0;
    }

    .employee-details h3 {
        font-size: 18px;
        margin-top: 15px;
        margin-bottom: 10px;
        color: #333;
    }

    .employee-details ul {
        padding-left: 20px;
    }

.leave-requests-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

    .leave-requests-table th, .leave-requests-table td {
        padding: 10px;
        border: 1px solid #ddd;
        text-align: left;
    }

    .leave-requests-table th {
        background-color: green;
        /* background-color: #009879; */
        color: #fff;
    }

    .leave-requests-table tbody tr:nth-child(even) {
        background-color: #f3f3f3;
    }
`, "",{"version":3,"sources":["webpack://./src/Pages/EmployeeView/EmployeeView.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;;AAEnB;AACA;IACI,WAAW;;AAEf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,gBAAgB,EAAE,8BAA8B;IAChD,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;IAEI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,eAAe;QACf,WAAW;IACf;;QAEI;YACI,WAAW;QACf;;IAEJ;QACI,YAAY;QACZ,0BAA0B;QAC1B,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;AAEJ;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,+BAA+B;QAC/B,WAAW;IACf;;IAEA;QACI,yBAAyB;IAC7B","sourcesContent":["/* EmployeeView.css */\n\n.employee-view-container {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.clickableattachments{\n    color: black;\n    cursor: pointer;\n    \n}\n.clickableattachments p:hover{\n    color: blue;\n    \n}\n\n.employee-card {\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    width: 100%;\n    max-width: 800px; /* Adjust width as necessary */\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n.employee-image {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-bottom: 20px;\n}\n\n.employee-details {\n    width: 100%;\n}\n\n    .employee-details h2 {\n        text-align: center;\n        margin-bottom: 20px;\n        color: #333;\n    }\n\n    .employee-details p {\n        margin: 5px 0;\n        font-size: 14px;\n        color: #666;\n    }\n\n        .employee-details p strong {\n            color: #333;\n        }\n\n    .employee-details hr {\n        border: none;\n        border-top: 1px solid #ddd;\n        margin: 20px 0;\n    }\n\n    .employee-details h3 {\n        font-size: 18px;\n        margin-top: 15px;\n        margin-bottom: 10px;\n        color: #333;\n    }\n\n    .employee-details ul {\n        padding-left: 20px;\n    }\n\n.leave-requests-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n}\n\n    .leave-requests-table th, .leave-requests-table td {\n        padding: 10px;\n        border: 1px solid #ddd;\n        text-align: left;\n    }\n\n    .leave-requests-table th {\n        background-color: green;\n        /* background-color: #009879; */\n        color: #fff;\n    }\n\n    .leave-requests-table tbody tr:nth-child(even) {\n        background-color: #f3f3f3;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
